import { useMemo } from 'react';
import { ScaleOrdinal as d3ScaleOrdinal } from 'd3';
import { getColorScale } from '../scheme';
import { ChartTheme, JSONArray, JSONObject } from '../types';
import { Theme } from '@redsift/design-system';

export interface UseColorProps {
  /** Dataset to use to generate the chart. */
  data: JSONArray;
  /** Color palette to use. */
  colorTheme: ChartTheme;
  /** Name of the field that will be used to categorize the data. */
  category: string | ((d: JSONObject) => string);
  /** Theme */
  theme: Theme;
}

export const useColor = ({ data, colorTheme, category, theme }: UseColorProps) => {
  const colorScale = useMemo<d3ScaleOrdinal<string, string>>(
    () =>
      getColorScale({
        colorTheme,
        domain: data.map((d) => (typeof category === 'string' ? (d[category] as string) : category(d))),
        theme,
      }),
    [colorTheme]
  );

  return colorScale;
};
